import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router} from '@angular/router';
import {Constants} from '../../../util/Constants';
import {AuthService} from "../../../services/auth-service/auth-service.service";

@Component({
  moduleId: module.id,
  selector: 'navbar',
  templateUrl: 'top-navbar.component.html',
  styleUrls: ['top-navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() title: string;
  @Input() openedSidebar = false;
  @Output() sidebarState = new EventEmitter();
  public profile: any;
  public fullName: string;

  constructor( public router: Router, public authService: AuthService) {
    if (JSON.parse(localStorage.getItem(Constants.PROFILE)) != null) {
      // console.log(' *******profile*******');
      this.profile = JSON.parse(localStorage.getItem(Constants.PROFILE)).data[0];
      // console.log(this.profile);
      if (this.profile) {
        this.fullName = this.profile.lastName + ' ' + this.profile.firstName;
      } else {
        router.navigate(['/sign-in']);
      }
    }
  }

  open(event) {
    const clickedComponent = event.target.closest('.nav-item');
    const items = clickedComponent.parentElement.children;

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
    clickedComponent.classList.add('opened');
  }

  close(event) {
    const clickedComponent = event.target;
    const items = clickedComponent.parentElement.children;

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
  }

  changePassword() {
    this.router.navigate(['admin/change-password']);
  }

  logout() {
   this.authService.logout();
  }

  openSidebar() {
    this.openedSidebar = !this.openedSidebar;
    this.sidebarState.emit();
  }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/menus/top-navbar/top-navbar.component.ts